module.exports = __webpack_public_path__ + "img/insur-item1.743dc52e.png";